// @ts-nocheck - Kallos 2.2.0 has React 18 TypeScript compatibility issues with ForwardRefExoticComponent
import { Button, Modal, ThemeProvider } from '@alphonsocode/kallos';
import React, { useState } from 'react';
import { MdWarningAmber } from 'react-icons/md';
import { useRetestMutation } from 'services/api/creativePreview';
import {
  describeError,
  startSelectiveSessionReplay,
  stopSelectiveSessionReplay,
  track,
} from 'analytics/posthog';
import Spinners from '../Spinner';

export function ConfirmModal({ open, setOpen, data, testType }) {
  const [triggerRetest, { isLoading }] = useRetestMutation();
  const [submitted, setSubmitted] = useState(false);
  const replaySource = 'adsure-retest';

  const handleRetry = async () => {
    setSubmitted(true);
    startSelectiveSessionReplay(replaySource);
    track('adsure retest confirmed', {
      test_id: data._id,
      adsure_test_tag: testType,
      surface: 'adsure',
    });
    try {
      await triggerRetest({ id: data._id, testType }).unwrap();
      setOpen(false);
      console.log('Retest triggered successfully');
    } catch (error) {
      track('adsure retest failed', {
        test_id: data._id,
        adsure_test_tag: testType,
        error_message: describeError(error),
        surface: 'adsure',
      });
      console.error('Error triggering retest:', error);
      setOpen(false);
    } finally {
      stopSelectiveSessionReplay(replaySource);
      setSubmitted(false);
    }
  };

  return (
    <ThemeProvider defaultMode="light">
      <Modal.Root open={open}>
        <Modal.Overlay />
        <Modal.Dialog size="sm">
          <Modal.Header
            closeButton
            onClick={() => setOpen(false)}
            style={{ borderBottom: 'none' }}
          />
          <Modal.Body style={{ position: 'relative'}}>
            {isLoading ? (
              <div
                style={{
                  display: 'flex',
                  justifyContent: 'center',
                  padding: '20px',
                }}
              >
                <Spinners count={4} color="#006e7d" />
              </div>
            ) : (
              <>
                <div
                  style={{
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    justifyContent: 'center',
                  }}
                >
                  <MdWarningAmber size={40} style={{ color: 'orange' }} />
                  <p
                    style={{
                      fontSize: '18px',
                      fontWeight: '500',
                      fontFamily: '"lg-smart", sans-serif',
                      marginBottom: '24px',
                    }}
                  >
                    Are you sure you want to retest this creative?
                  </p>
                </div>

                <div
                  style={{
                    display: 'flex',
                    gap: '12px',
                    justifyContent: 'center',
                  }}
                >
                  <Button
                    type="button"
                    onClick={handleRetry}
                    colorVariant="deepGreen"
                    variant="outlined"
                    disableHoverEffect
                    disabled={submitted}
                    style={{
                      width: '100%',
                      marginBottom: '8px',
                      marginTop: '-8px',
                    }}
                  >
                    Yes
                  </Button>
                  <Button
                    onClick={() => setOpen(false)}
                    colorVariant="deepGreen"
                    variant="rounded"
                    disableHoverEffect
                    style={{
                      width: '100%',
                      marginBottom: '8px',
                      marginTop: '-8px',
                    }}
                  >
                    No
                  </Button>
                </div>
              </>
            )}
          </Modal.Body>
        </Modal.Dialog>
      </Modal.Root>
    </ThemeProvider>
  );
}
